import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6664e63e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-item invite-persion-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-item" }, [
  /*#__PURE__*/_createElementVNode("div", null, "你目前已成功推荐人数")
], -1))
const _hoisted_3 = { class: "block-item" }
const _hoisted_4 = { class: "tag-wrap" }
const _hoisted_5 = { class: "process-line" }
const _hoisted_6 = { class: "bg-item" }
const _hoisted_7 = { class: "circle-wrap" }
const _hoisted_8 = { class: "number-wrap" }

import { computed, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'claim-invite-person',
  props: {
    crrentActiveVal: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { crrentActiveVal: number };



const tagList = computed(() => {
  return [1, 2, 3].map((val, index) => {
    return {
      text: `奖励${val}`,
      value: val,
      active: props.crrentActiveVal / 2 > index,
    }
  })
})
const circleList = computed(() => {
  return '01234'.split('').map((item, index) => {
    return {
      active: props.crrentActiveVal > index,
    }
  })
})
const numList = computed(() => {
  return '12345'.split('').map((item, index) => {
    return {
      text: `${item}人`,
      active: props.crrentActiveVal > index,
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tagList), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.value,
            class: _normalizeClass(item.active ? 'tag-active' : '')
          }, [
            _createElementVNode("div", null, _toDisplayString(item.text), 1)
          ], 2))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["active-process-item", 'active-process-item' + __props.crrentActiveVal])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(circleList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(item?.active ? 'circle-active' : '')
            }, null, 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numList), (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(item?.active ? 'number-active' : '')
          }, _toDisplayString(item.text), 3))
        }), 128))
      ])
    ])
  ]))
}
}

})